// src/features/inventory/scannerScopes.js

// What the scanner needs to look an item up and book stock: the same scopes a
// scanner phone gets (SCANNER_SCOPES in the API). Staff need all of them to open it.
export const SCANNER_STAFF_SCOPES = [
  'inventory:item:read',
  'inventory:product-group:read',
  'inventory:lot:read',
  'inventory:stock:read',
  'inventory:stock:record',
];

// The hidden test barcode page builds its codes from items, product groups and lots
export const TEST_BARCODE_SCOPES = ['inventory:item:read', 'inventory:product-group:read', 'inventory:lot:read'];
